import React from 'react';
import { SVGIcon } from '../../../../../components';
import { COLOUR_BRANDING_MAIN, hexToRGBAstring } from '../../../../../js';

export default () => {
  return (
    <div className="fp2_widget_content fp2_widget_content-gallery">
      <div className="fp2_widget_content_half">
        <div className="fp2_widget_silhouette fp2_widget_silhouette-rectangle">
          <div className="fp2_widget_silhouette_icon">
            <SVGIcon icon={'image'} colour={hexToRGBAstring(COLOUR_BRANDING_MAIN, 0.5)} />
          </div>
        </div>
        <div className="fp2_widget_silhouette fp2_widget_silhouette-textLineLong"></div>
      </div>

      <div className="fp2_widget_content_half">
        <div className="fp2_widget_silhouette fp2_widget_silhouette-rectangle">
          <div className="fp2_widget_silhouette_icon">
            <SVGIcon icon={'image'} colour={hexToRGBAstring(COLOUR_BRANDING_MAIN, 0.5)} />
          </div>
        </div>
        <div className="fp2_widget_silhouette fp2_widget_silhouette-textLineLong"></div>
      </div>
    </div>
  );
};
